export default __webpack_public_path__ + "static/media/sp_info_deactive.37314146.svg";